// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import { IconRepeat } from '@tabler/icons-react';
import { useState } from 'react';
import { lookupField } from '../fieldMetadata';
import { SynqoForEachMode, type SynqoForEachCondition, type SynqoRuleset } from '@Model';
import { ACCENT } from './accent';
import { ConditionCard, ConditionCardHeader } from './ConditionCard';
import { ConditionVisitor } from './ConditionVisitor';

interface ForEachRendererProps {
    node: SynqoForEachCondition;
    referencedRulesets: Record<string, SynqoRuleset>;
}

export function ForEachRenderer({ node, referencedRulesets }: ForEachRendererProps) {
    const [expanded, setExpanded] = useState(true);
    const collectionLabel = lookupField(node.collection.path)?.label ?? node.collection.path;
    const modeLabel = node.mode === SynqoForEachMode.All ? 'alle Einträge' : 'mindestens ein Eintrag';

    return (
        <ConditionCard accent={ACCENT.for_each}>
            <ConditionCardHeader
                expanded={expanded}
                onToggle={() => setExpanded((prev) => !prev)}
                icon={<IconRepeat size={16} className={`shrink-0 ${ACCENT.for_each.icon}`} />}
                title={
                    <>
                        <span className="text-(--mantine-color-text-5)">Für</span>{' '}
                        <span className="text-(--mantine-color-primary-text) font-semibold">{modeLabel}</span>{' '}
                        <span className="text-(--mantine-color-text-5)">in</span>{' '}
                        <span className="font-mono text-(--mantine-color-text-7)">{collectionLabel}</span>{' '}
                        <span className="font-normal text-(--mantine-color-text-4)">gilt:</span>
                    </>
                }
            />
            {expanded && (
                <div className="mt-2 pl-1">
                    <ConditionVisitor node={node.body} referencedRulesets={referencedRulesets} />
                </div>
            )}
        </ConditionCard>
    );
}
